import { showDate } from '../../lib/dateFormater';
import { getAllProjects } from '../../API/Projects/projectsService';
import { ProjectsType } from '../../data/types';
import { Fragment, ReactNode, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { CheckCircle, CircleDot } from 'lucide-react';
import {
  Carousel,
  CarouselActionButton,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../ui/carousel';
import TravauxCard from '../TravauxCard';

type Props = {
  children?: ReactNode;
};

const WorkHomeSection = (props: Props) => {
  const [projects, setProjects] = useState<ProjectsType[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllProjects();
      if (response?.projects) {
        const sortedProjects = response.projects
          .slice(0, 4)
          .sort(
            (a: any, b: any) => new Date(a.date_fin).getTime() - new Date(b.date_fin).getTime()
          );
        setProjects(sortedProjects);
      }
    };

    fetchData();
  }, []);

  return (
    <Fragment>
      <div className="p-1 md:p-24" style={{ zIndex: 0 }}>
        <div className="text-3xl font-bold text-center text-black">Travaux En cours</div>
        <div className="container">
          <Carousel opts={{ align: 'start', loop: true }} className="w-full mt-20">
            <CarouselContent>
              {projects.map(item => (
                <CarouselItem key={item.id} className="basis-auto">
                  <TravauxCard projets={item} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-between mt-10 mr-10">
              <div className="items-center"></div>
              {/* Spacer to push content to the right */}
              <div className="flex justify-center">
                <CarouselActionButton
                  title="Tous les travaux"
                  navigateLink="/travaux"
                  className="mx-auto"
                />
              </div>
              <div className="flex gap-1">
                <CarouselPrevious
                  inlineStyle={true}
                  className="relative text-white rounded-lg hover:bg-secondary bg-neutral-100 hover:text-white bg-primary"
                />
                <CarouselNext
                  inlineStyle={true}
                  className="relative text-white rounded-lg hover:bg-secondary bg-neutral-100 hover:text-white bg-primary"
                />
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </Fragment>
  );
};

export default WorkHomeSection;
